module.exports = __webpack_public_path__ + "static/media/save_icon.6a2c68dd.svg";